{
  "title": "Air Bubble",
  "source": "Spelljammer: Adventures in Space - Astral Adventurer's Guide",
  "levelAndSchool": "2nd-Level Conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S",
  "duration": "24 hours",
  "description": [
    "You create a spectral globe around the head of a willing creature you can see within range. The globe is filled with fresh air that lasts until the spell ends. If the creature has more than one head, the globe of air appears around only one of its heads (which is all the creature needs to avoid suffocation, assuming that all its heads share the same respiratory system).",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can create two additional globes of fresh air for each slot level above 2nd."
  ],
  "spellLists": ["artificer", "druid", "ranger", "sorcerer", "wizard"]
}
